const MuiAutocomplete = {
  styleOverrides: {
    option: {
      fontSize: '1.4rem',
    },
  },
};

export default MuiAutocomplete;
